export const isPlatformFlagEnabled = value => (
  value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true'
);

export const getPlatformStatus = (store, meituanConfidence, elemeConfidence) => ({
  onMeituan: isPlatformFlagEnabled(store.is_on_meituan)
    && Number(store.mapping_meituan_similarity || 0) >= meituanConfidence,
  onEleme: isPlatformFlagEnabled(store.is_on_eleme)
    && Number(store.mapping_eleme_similarity || 0) >= elemeConfidence,
});

export const filterStoresByPlatform = (
  items,
  meituanConfidence,
  elemeConfidence,
  source = 'all',
) => (items || []).filter(store => {
  const { onMeituan, onEleme } = getPlatformStatus(store, meituanConfidence, elemeConfidence);
  // “全部”是全部符合地区/门店类型条件的 POI，不要求上线 O2O。
  if (source === 'all') return true;
  if (source === 'meituan') return onMeituan;
  if (source === 'eleme') return onEleme;
  return true;
});
